import http from '@/config/api';
import router from '@/router';

export default {
  async getTopics({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    await http
      .get(`event/${directory}/topics`, {
        params: {
          type: payload.typeTopic,
          offset: payload.offset,
          limit: payload.limit,
        },
      })
      .then((res) => {
        commit('ADD_TOPICS', res.data);
      });
  },
  async getTopicsInFiveDays({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const res = await http
      .get(`event/${directory}/topics/checkingBell`, {
        params: payload,
      })
      .then(
        (res) => {
          commit('SET_TOPICS_IN_FIVE_DAYS', res.data.list);
          return res.data;
        },
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return res;
  },
  async getTopicDetail({ commit }, topicId) {
    const directory = router.currentRoute.value?.params.directory;
    await http.get(`event/${directory}/topic/${topicId}`).then((res) => {
      commit('SET_TOPIC_DETAIL', res.data);
    });
  },
  async resetState({ commit }) {
    commit('RESET_STATE');
  },
};
